<template>
  <v-app>
    <v-toolbar color="black" clipped-right clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" color="orange"></v-toolbar-side-icon>
      <v-toolbar-title>
        <span style="color:orange;">{{Name}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn to="/about" v-on="on" flat>
              <v-icon dark color="orange">info</v-icon>
            </v-btn>
          </template>
          <span style="color:black">About</span>
        </v-tooltip>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="signout" v-on="on" flat>
              <v-icon dark color="orange">meeting_room</v-icon>
            </v-btn>
          </template>
          <span style="color:black">Sign Out</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" :mini-variant="mini" absolute dark temporary>
      <v-list class="pa-1">
        <v-list-tile v-if="mini" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar tag="div">
          <v-list-tile-avatar>
            <v-avatar v-if="userPhoto">
              <v-dialog max-width="500px">
                <template v-slot:activator="{ on }">
                  <img :src="userPhoto" v-on="on" />
                </template>
                <v-card hover>
                  <v-container grid-list-md>
                    <v-layout row>
                      <v-flex xs12 sm6 md4 reverse>
                        <v-img :src="userPhoto"></v-img>
                      </v-flex>
                      <v-layout column justify-center align-center>
                        <h1>
                          <v-icon>arrow_drop_down</v-icon>Photo URL
                          <v-icon>arrow_drop_down</v-icon>
                        </h1>
                        <h3>{{userPhoto}}</h3>
                        <h5>[ Size : 200x300 px ]</h5>
                      </v-layout>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-avatar>
            <v-avatar v-else>
              <v-icon>person</v-icon>
            </v-avatar> 
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-text-field v-model="Name" :value="Name" @change="chgname" color="orange"></v-text-field>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="mini = !mini">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list two-line dense>
        <v-divider light></v-divider>
        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="orange">lock</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Password</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <span class="headline">Change {{ Name }} Password</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap column>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        label="Current Password"
                        type="password"
                        v-model="password.old"
                        color="orange"
                      ></v-text-field>
                      <v-text-field
                        label="New Password"
                        type="password"
                        v-model="password.new"
                        color="orange"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" flat @click="chgpw">Change</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="orange">photo_library</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Photo Profile</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <span class="headline">Pick Preferred Image</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap column>
                    <v-flex xs12 sm6 md4>
                      <v-avatar v-for="(p,i) in photos" :key="i">
                        <img :src="p" @click="chgphoto(p)" />
                      </v-avatar>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="orange">book</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-dialog v-model="mdlDlg" fullscreen max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Modules</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <v-layout justify-center>
                    <span class="headline" style="color:orange">Input New Modules</span>
                  </v-layout>
                </v-card-title>
                <v-container>
                  <v-text-field label="Name" v-model="LPECmodules.workshop" color="orange"></v-text-field>
                  <v-text-field label="Description" v-model="LPECmodules.desc" color="orange"></v-text-field>
                  <v-text-field label="Logo URL" v-model="LPECmodules.img" color="orange"></v-text-field>
                  <span class="headline" style="color:orange">List Of Added Modules</span>
                  <div v-for="(i,n) in list" :key="n">
                    <v-chip>
                      <v-avatar>
                        <v-img :src="i.img"></v-img>
                      </v-avatar>
                      {{i.workshop}}
                      <v-spacer></v-spacer>
                      <v-icon small @click="delModules(i)">clear</v-icon>
                    </v-chip>
                  </div>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" flat @click="mdlDlg = !mdlDlg">Close</v-btn>
                  <v-btn color="orange" flat @click="newModules">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="orange">score</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-dialog v-model="scrDlg" max-width="850px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Scores</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <span class="headline">Score List</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  color="orange"
                  single-line
                  flat
                  box
                  hide-details
                ></v-text-field>
                <v-data-table
                  :headers="scoreHeaders"
                  :items="table"
                  class="elevation-1"
                  :search="search"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      <v-avatar size="30">
                        <img :src="props.item.photo" />
                      </v-avatar>
                      {{ props.item.username }}
                    </td>
                    <td class="text-xs-center">{{props.item.date}}</td>
                    <td class="text-xs-center">{{props.item.type}}</td>
                    <td class="text-xs-center">{{props.item.pretest}}</td>
                    <td class="text-xs-center">{{props.item.posttest}}</td>
                    <td class="text-xs-center">{{props.item.status}}</td>
                    <td class="justify-center layout px-0">
                      <v-icon small class="mr-2" @click="editScore(props.item)">edit</v-icon>
                      <v-icon small @click="deleteScore(props.item)">delete</v-icon>
                    </td>
                  </template>

                  <v-layout align-center justify-center>
                    <template v-slot:no-data>
                      <div>No Data Available</div>
                    </template>
                  </v-layout>
                </v-data-table>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="orange">feedback</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-dialog v-model="fdbDlg" fullscreen max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Feedback Viewer</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <v-layout justify-center>
                    <span class="headline" style="color:orange">Feedback</span>
                  </v-layout>
                </v-card-title>
                <v-container v-for="(i,n) in feedback" :key="n">
                  <v-text-field readonly label="name" outline v-model="i.name" color="orange"></v-text-field>
                  <v-text-field readonly label="title" outline v-model="i.title" color="orange"></v-text-field>
                  <v-textarea readonly outline label="message" v-model="i.message" color="orange"></v-textarea>
                  <v-divider style="color:black"></v-divider>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" flat @click="fdbDlg = !fdbDlg">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="orange">settings</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-dialog v-model="optDlg" fullscreen max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Options</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title center>
                  <v-layout align-center>
                    <span class="headline" style="color:orange">Settings</span>
                    <v-layout column align-end><v-btn icon @click="optDlg = !optDlg"><v-icon color="red">close</v-icon></v-btn></v-layout>
                  </v-layout>
                </v-card-title>
                <v-container>
                  <v-layout v-for="(i,n) in list" :key="n" column justify-space-between>
                    <v-divider style="color:black"></v-divider>
                      <v-layout row>
                        <v-icon v-if="i.availability" class="mx-2">lock_open</v-icon>
                        <v-icon v-else class="mx-2">lock</v-icon>
                        <div class="my-4 mr-2" style="color:orange">{{i.workshop}}</div>
                        <v-switch v-model="i.availability" @change="webconfig(i,n)" color="orange"></v-switch>
                      </v-layout>
                      <v-layout row justify-space-around align-center class="my-4">
                        <v-card hover><v-switch class="mx-1" :disabled="!i.availability" v-model="i.pretest" @change="webconfig(i,n)" color="orange" label="Pre-Test"></v-switch> </v-card>
                        <v-card hover><v-switch class="mx-1" :disabled="!i.availability" @change="webconfig(i,n)" v-model="i.posttest" color="orange" label="Post-Test"></v-switch></v-card>
                        <v-card hover><v-switch class="mx-1" :disabled="!i.availability" v-model="i.LiveVE" @change="webconfig(i,n)" color="orange" label="Live VE"></v-switch></v-card>
                        <v-card hover>  
                          <v-layout column align-center>
                            <v-switch :disabled="!i.availability" v-model="i.duration['status']" @change="webconfig(i,n)" color="orange" label="Timer"></v-switch>
                            <v-layout>
                              <v-text-field class="mx-2" :disabled="!i.duration['status'] || !i.availability" v-model="i.duration['pre-test']" persistent-hint hint="Format HH:MM:SS" box return-masked-value mask="time-with-seconds" @change="webconfig(i,n)" label="pre-test"></v-text-field>
                              <v-text-field class="mx-2" :disabled="!i.duration['status'] || !i.availability" v-model="i.duration['post-test']" persistent-hint hint="Format HH:MM:SS" box return-masked-value mask="time-with-seconds" @change="webconfig(i,n)" label="post-test"></v-text-field>
                            </v-layout>
                          </v-layout>
                        </v-card>
                      </v-layout>
                    <v-divider style="color:black"></v-divider>
                  </v-layout>
                </v-container>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-parallax
      :src="require('@/assets/21.jpg')"
      height="100%"
      style="width: 100%; 
    height: 100%; 
    position: relative; "
    >
      <v-container>
        <v-card :color="props.color" :flat="props.flat" :dark="props.bool" :hover="props.bool">
          <v-layout justify-center align-center>
            <v-bottom-sheet v-model="sheet" value>
              <template v-slot:activator>
                <v-btn color="orange" dark round>
                  <v-icon color="black">arrow_right</v-icon>
                  <div v-if="bottomnav" style="color:black">{{bottomnav}}</div>
                  <div v-else style="color:black">Select Modules</div>
                  <v-divider></v-divider>
                  <v-icon color="black">arrow_left</v-icon>
                </v-btn>
              </template>
              <v-list dark expand two-line>
                <v-subheader style="color:orange">
                  <v-layout justify-center align-center>
                    <v-icon color="black">arrow_drop_down</v-icon>
                    <h3>Available Module List</h3>
                    <v-icon color="black">arrow_drop_down</v-icon>
                  </v-layout>
                </v-subheader>
                <v-divider></v-divider>
                <v-layout justify-center align-center>
                  <div class="mx-2 my-2" v-for="(ls,i) in list" :key="i">
                    <v-card hover @click="selectmodules(ls.workshop)" color="orange">
                      <v-layout column align-center>
                        <v-avatar ls.workshop>
                          <img :src="ls.img" :alt="ls.workshop" @click="selectmodules(ls.workshop)" />
                        </v-avatar>
                        <div class="mx-2"  style="color: black">{{ ls.workshop }}</div>
                      </v-layout>
                    </v-card>
                  </div>
                </v-layout>
              </v-list>
            </v-bottom-sheet>
          </v-layout>
          <v-text-field
            v-if="bottomnav"
            v-model="search2"
            append-icon="search"
            label="Search"
            color="orange"
            single-line
            flat
            box
            hide-details
          ></v-text-field>
          <v-data-table
            v-if="bottomnav"
            :headers="headers"
            :items="quiz"
            class="elevation-4"
            :search="search2"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.text }}</td>
              <td class="text-xs-center">{{ props.item.type }}</td>
              <td class="text-xs-center">{{ props.item.a }}</td>
              <td class="text-xs-center">{{ props.item.b }}</td>
              <td class="text-xs-center">{{ props.item.c }}</td>
              <td class="text-xs-center">{{ props.item.d }}</td>
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>

            <v-layout align-center justify-center>
              <template v-slot:no-results>
                <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                >Your search for "{{ search }}" found no results.</v-alert>
              </template>
              <template v-slot:no-data>
                <div>No Data Available</div>
              </template>
            </v-layout>
          </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" persistent fullscreen max-width="500px" v-if="bottomnav">
          <template v-slot:activator="{ on }">
            <div style="position:relative">
              <v-btn absolute fab bottom left color="orange" v-on="on" @click="form = {}">
                <v-icon>add</v-icon>
              </v-btn>
            </div>
          </template>
          <v-card hover>
            <v-card-title>
              <v-layout justify-center>
                <span class="headline" style="color:orange">Question</span>
              </v-layout>
            </v-card-title>
            <v-container>
              <v-textarea label="Question" box color="orange" auto-grow v-model="form.text"></v-textarea>
              <v-spacer></v-spacer>
              <v-layout justify-center align-center>
                <span style="color:orange" class="headline">Answer And Text Option</span>
              </v-layout>
              <v-radio-group v-model="form.answer" row>
                <v-layout row>
                  <v-radio color="orange" label="A" value="a"></v-radio>
                  <v-textarea label box color="orange" auto-grow v-model="form.a"></v-textarea>
                </v-layout>
                <v-layout row>
                  <v-radio color="orange" label="B" value="b"></v-radio>
                  <v-textarea label box color="orange" auto-grow v-model="form.b"></v-textarea>
                </v-layout>
                <v-layout row>
                  <v-radio color="orange" label="C" value="c"></v-radio>
                  <v-textarea label box color="orange" auto-grow v-model="form.c"></v-textarea>
                </v-layout>
                <v-layout row>
                  <v-radio color="orange" label="D" value="d"></v-radio>
                  <v-textarea label box color="orange" auto-grow v-model="form.d"></v-textarea>
                </v-layout>
              </v-radio-group>

              <v-layout justify-center align-center>
                <span style="color:orange" class="headline">Pretest / Posttest ?</span>
              </v-layout>
              <v-layout justify-space-between align-content-space-between>
                <v-spacer></v-spacer>
                <v-checkbox label="Pre-test" v-model="form.pretest" @change="chckbx" color="orange"></v-checkbox>
                <v-checkbox
                  label="Post-test"
                  v-model="form.posttest"
                  @change="chckbx"
                  color="orange"
                ></v-checkbox>
              </v-layout>
              <v-layout justify-center align-center align-content-center row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" @click="close">Cancel</v-btn>
                  <v-btn color="orange" @click="dialog = false;save()">Save</v-btn>
                </v-card-actions>
              </v-layout>
            </v-container>
          </v-card>
        </v-dialog>
      </v-container>
    </v-parallax>
    <v-bottom-nav active.sync :value="true" color="black">
      <v-layout justify-center>
        <v-tooltip top color="orange">
          <template v-slot:activator="{on}">
            <v-btn to="/score" v-on="on" flat>
              <v-icon dark color="orange">assessment</v-icon>
            </v-btn>
          </template>
          <span style="color:black">Score</span>
        </v-tooltip>
        <v-tooltip top color="orange">
          <template v-slot:activator="{on}">
            <v-btn to="/exam" v-on="on" flat>
              <v-icon dark color="orange">home</v-icon>
            </v-btn>
          </template>
          <span style="color:black">Home</span>
        </v-tooltip>
        <v-tooltip top color="orange">
          <template v-slot:activator="{on}">
            <v-btn to="/files" v-on="on" flat>
              <v-icon dark color="orange">list</v-icon>
            </v-btn>
          </template>
          <span style="color:black">Files</span>
        </v-tooltip>
      </v-layout>
    </v-bottom-nav>
    <v-dialog v-model="ScoreForm" persistent max-width="500px">
      <v-card hover>
        <v-card-title>
          <v-layout justify-center>
            <span class="headline" style="color:orange">Edit Score</span>
          </v-layout>
        </v-card-title>
        <v-container>
          <v-text-field :value="Scoretmp.username" readonly color="orange"></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field label="Pre-test" v-model.number="Scoretmp.pretest" color="orange"></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field label="Post-test" v-model.number="Scoretmp.posttest" color="orange"></v-text-field>
          <v-spacer></v-spacer>
          <v-layout justify-center align-center align-content-center row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="orange"
                style="color:white"
                @click="ScoreForm = !ScoreForm;scrDlg=!scrDlg"
              >Close</v-btn>
              <v-btn
                color="orange"
                style="color:white"
                @click="saveScore();ScoreForm = !ScoreForm;scrDlg=!scrDlg"
              >Save</v-btn>
            </v-card-actions>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import firebase from "firebase";
import router from "@/router";

const _auth = firebase.auth();
const _db = firebase.firestore();

export default {
  data() {
    return {
      duration: '',
      search2: "",
      fdbDlg: false,
      mdlDlg: false,
      scrDlg: false,
      optDlg: false,
      sheet: true,
      password: { new: "", old: "" },
      Name: "",
      list: {},
      bottomnav: "",
      drawer: null,

      mini: false,
      //FORM
      edit: {},
      form: {},
      LPECmodules: {},

      //TABLE
      search: "",
      title: 0,
      dialog: false,
      editor: false,
      headers: [
        {
          text: "Questions",
          value: "text",
          sortable: true,
          align: "center"
        },
        { text: "Type", value: "type", sortable: true, align: "center" },
        { text: "Option A", value: "a", sortable: true, align: "center" },
        { text: "Option B", value: "b", sortable: true, align: "center" },
        { text: "Option C", value: "c", sortable: true, align: "center" },
        { text: "Option D", value: "d", sortable: true, align: "center" },
        { text: "Actions", sortable: false, align: "center" }
      ],
      scoreHeaders: [
        { text: "Name", value: "username", sortable: true, align: "center" },
        {
          text: "Date",
          value: "date",
          sortable: true,
          align: "center"
        },
        {
          text: "Modules",
          value: "type",
          sortable: true,
          align: "center"
        },
        {
          text: "Pre-test",
          value: "pretest",
          sortable: true,
          align: "center"
        },
        {
          text: "Post-test",
          value: "posttest",
          sortable: true,
          align: "center"
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          align: "center"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false
        }
      ],
      quiz: [],
      table: [],
      props: { bool: false, color: "transparent", value: false, flat: true },
      userPhoto: "",
      Scoretmp: {},
      ScoreForm: false,
      photos: [],
      feedback: {}
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  // Getting All Admin Features Data
  mounted() {
    this.Name = _auth.currentUser.displayName;
    this.userPhoto = _auth.currentUser.photoURL;
    for (let i = 0; i <= 107; i++) {
      const rand = Math.floor(Math.random() * 999);
      this.photos.push("https://picsum.photos/id/" + rand + "/200/300");
    }

    var temp;
    _db.collection("scores").onSnapshot(e => {
      temp = e.docs.map(doc => {
        return doc.data();
      });
      this.table = temp;
      temp = undefined;
    });
    _db.collection("modules").onSnapshot(e => {
      temp = e.docs.map(doc => {
        return doc.data();
      });
      this.list = temp;
      temp = undefined;
    });
    _db.collection("feedback").onSnapshot(e => {
      temp = e.docs.map(doc => {
        return doc.data();
      });
      this.feedback = temp;
      temp = undefined;
    });
  },

  methods: {
    newModules: function() {
      (this.LPECmodules.pretest = false),
        (this.LPECmodules.posttest = false),
        _db
          .collection("modules")
          .doc(this.LPECmodules.workshop)
          .set(this.LPECmodules)
          .then(alert("Module added to system"))
          .catch(r => {
            alert(r);
          });
    },
    delModules: function(ref) {
      _db
        .collection("modules")
        .doc(ref.workshop)
        .delete()
        .then(() => {
          alert("Module deleted");
        })
        .catch(r => {
          alert(r);
        });
    },
    chckbx: function() {
      if (this.form.pretest == this.form.posttest) {
        this.form.type = "Pre-test & Post-test";
      } else if (this.form.pretest == true) this.form.type = "Pre-test";
      else this.form.type = "Post-test";
    },

    //config
    webconfig: function(ref, index) { 
      _db
        .collection("modules")
        .doc(ref.workshop)
        .update(this.list[index])
        .catch(r => {
          alert(r);
        });
    },
    chgphoto: function(v) {
      this.userPhoto = v;
      _auth.currentUser.updateProfile({ photoURL: v }).catch(er => {
        alert(er);
      });
    },
    chgname: function() {
      firebase
        .auth()
        .currentUser.updateProfile({ displayName: this.Name })
        .catch(e => alert(e));
    },
    chgpw: function() {
      _auth.currentUser
        .reauthenticateWithCredential(
          firebase.auth.EmailAuthProvider.credential(
            _auth.currentUser.email,
            this.password.old
          )
        )
        .then(
          _auth.currentUser
            .updatePassword(this.password.new)
            .then(e => alert("password updated succesfully ", e))
            .catch(r => alert(r))
        );
    },
    selectmodules: function(v) {
      this.quiz = [];
      this.bottomnav = v;
      this.props.bool = true;
      this.props.color = "";
      this.props.flat = false;
      this.sheet = false;
      _db
        .collection("modules")
        .doc(this.bottomnav)
        .collection("questions")
        .onSnapshot(e => {
          this.quiz = e.docs.map(doc => {
            return doc.data();
          });
        });
    },
    signout: function() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          router.push("/");
        });
    },
    save: function() {
      if (this.form.id) {
        _db
          .collection("modules")
          .doc(this.bottomnav)
          .collection("questions")
          .doc(this.form.id)
          .update(this.form);
      } else {
        _db
          .collection("modules")
          .doc(this.bottomnav)
          .collection("questions")
          .add(this.form)
          .catch(e => alert(e))
          .then(t => {
            t.update({ id: t.id });
          });
      }
      this.form = {};
    },

    editItem(items) {
      this.form = Object.assign({}, items);
      this.dialog = true;
    },

    deleteItem(item) {
      _db
        .collection("modules")
        .doc(this.bottomnav)
        .collection("questions")
        .doc(item.id)
        .delete();
    },

    editScore(items) {
      this.Scoretmp = items;
      this.scrDlg = !this.scrDlg;
      this.ScoreForm = !this.ScoreForm;
    },

    saveScore() {
      if (!this.Scoretmp.posttest && this.Scoretmp.pretest < 60)
        this.Scoretmp.status = "Not good";
      else if (this.Scoretmp.pretest && this.Scoretmp.posttest)
        if ((this.Scoretmp.pretest + this.Scoretmp.posttest) / 2 < 60)
          this.Scoretmp.status = "Not Good";
        else this.Scoretmp.status = "Good";
      else this.Scoretmp.status = "Good";
      _db
        .collection("scores")
        .doc(this.Scoretmp.id)
        .update(this.Scoretmp)
        .then(alert("Score Updated"))
        .catch(r => {
          alert(r);
        });
    },

    deleteScore(item) {
      _db
        .collection("scores")
        .doc(item.id)
        .delete()
        .then()
        .catch(r => {
          alert("error " + r);
        });
    },

    close() {
      this.dialog = false;
    }
  }
};
</script>
